import React, { useState, useRef } from "react";
import { Autocomplete, SortMenu, Typography } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";

const Filters = ({
  onSearchChange,
  onSortChange,
  onOrderChange,
  selectedSortOption = "createdAt",
  orderDirection = "desc",
  loading = false,
}) => {
  const [autocompleteValue, setAutocompleteValue] = useState("");
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const autocompleteRef = useRef(null);

  const handleSearchChange = (value) => {
    setAutocompleteValue(value);
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const handleSearchClear = () => {
    setAutocompleteValue("");
    setAutocompleteKey((prev) => prev + 1);

    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }

    if (onSearchChange) {
      onSearchChange("");
    }
  };

  return (
    <>
      <Typography category="title" size="small" weight="bold">Choose how to start your new role</Typography>
      <FiltersContainer>
        <FiltersLeftContent>
          <Autocomplete
            key={autocompleteKey}
            ref={autocompleteRef}
            value={autocompleteValue}
            onChange={handleSearchChange}
            onSearch={() => { }}
            onSuggestionSelect={() => { }}
            onClear={handleSearchClear}
            placeholder="Search"
            disabled={loading}
            suggestions={[]}
          />
        </FiltersLeftContent>

        <FiltersRightContent>
          <SortMenu
            minWidth="200px"
            onChange={onSortChange || (() => { })}
            onOrderChange={onOrderChange || (() => { })}
            options={[
              {
                icon: 'sortByAlpha',
                id: 'name',
                label: 'Name (A-Z)'
              },
              {
                icon: 'group',
                id: 'userCount',
                label: 'User Count'
              }
            ]}
            order={orderDirection.toLowerCase()}
            selected={selectedSortOption}
            size="medium"
            title="SORT BY"
            width="240px"
            disabled={loading}
          />
        </FiltersRightContent>
      </FiltersContainer>
    </>
  );
};

export default Filters;

